import './css/Socials.css'

export default function Socials () {
            return (
                <div className="socialsContainer">
                    <div className="discord">
                        <span>Discord</span>
                    </div>

                    <div className="twitter">
                    <span>Twitter</span>
                    </div>

                    <div className="facebook">
                    <span>Facebook</span>
                    </div>
                </div>
            )
}